import { Helmet } from 'react-helmet'

import { Cap } from '../../primitives'
import { PrototypeFrame } from '../../PrototypeFrame'
import { ConfirmInfoCards } from './ConfirmInfoCards'

const BRIEF = (
  <div className="border-ink-700 grid grid-cols-1 gap-6 border-t pt-6 sm:grid-cols-2 lg:grid-cols-4">
    <div>
      <Cap onDark>Goal</Cap>
      <p className="text-ink-200 mt-2 text-xs leading-relaxed">
        Swap the flat grey icon circles on the Confirm info step for the new isometric illustrations, shown
        bare with no circle or fill behind them. Testing whether the heavier artwork helps customers scan the
        step and reach &quot;Confirm and continue&quot; faster, without the cards feeling busy. Metric:
        completion rate of the Confirm info step (baseline TBD).
      </p>
    </div>

    <div>
      <Cap onDark>Project: Sub-5 self-serve</Cap>
      <p className="text-ink-200 mt-2 text-xs leading-relaxed">
        Confirm info is the last screen before a customer commits their application. It is dense with data
        they have to check, so anything that makes it quicker to read protects the self-serve path.
      </p>
    </div>

    <div>
      <Cap onDark>Feedback</Cap>
      <ul className="text-ink-200 mt-2 flex flex-col gap-1 text-xs leading-relaxed">
        <li>
          Slack channel:{' '}
          <a
            href="https://cailabsinc.slack.com/archives/C0BJYN811JQ"
            target="_blank"
            rel="noopener noreferrer"
            className="text-brand-300 hover:text-brand-200 underline underline-offset-2"
          >
            #test-application-sub-5-self-serve
          </a>
        </li>
      </ul>
    </div>

    <div>
      <Cap onDark>Next</Cap>
      <p className="text-ink-200 mt-2 text-xs leading-relaxed">
        Settle the illustration size and whether Claims keeps an icon at all, then swap the artwork into the
        real chat components. The illustrations are fixed black line art today, so they will need a dark-mode
        answer before they ship.
      </p>
    </div>
  </div>
)

export function ConfirmInfoCardsPrototypePage() {
  return (
    <PrototypeFrame
      title="Confirm info cards V1.0"
      owner="Carrie Phillips"
      date="August 31, 2026"
      status="Front-end prototype"
      brief={BRIEF}
    >
      <Helmet>
        <title>Prototype: Confirm info cards V1.0</title>
      </Helmet>
      <ConfirmInfoCards />
    </PrototypeFrame>
  )
}
